"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var UrlUtils = /** @class */ (function () {
    function UrlUtils() {
    }
    UrlUtils.init = function (helpUrl) {
        this._helpUrl = helpUrl;
    };
    Object.defineProperty(UrlUtils, "helpUrl", {
        get: function () {
            return this._helpUrl;
        },
        enumerable: true,
        configurable: true
    });
    UrlUtils.getDatasourcePage = function (siteUrlName, unifiedDatasourceId) {
        return UrlUtils.getDatasourcePageForWindow(siteUrlName, unifiedDatasourceId, window.location);
    };
    UrlUtils.getDatasourceOwnerWorkbook = function (unifiedDatasourceId) {
        var baseUrl = window.location.origin;
        return baseUrl + "/vizql/showadminview/datasources/DatasourceOwnerPanel?datasource_id=" + unifiedDatasourceId;
    };
    UrlUtils.getDatasourcePageForWindow = function (siteUrlName, unifiedDatasourceId, windowLocation) {
        var baseUrl = windowLocation.origin;
        var siteUrl = siteUrlName === '' ? '' : "/site/" + siteUrlName;
        var paramsWithHash = queryString.stringify(queryString.parseUrl(windowLocation.href).query, { encode: false });
        var parameters = paramsWithHash.length > 0 ? "?" + paramsWithHash.split('#')[0] : '';
        return baseUrl + "/#" + siteUrl + "/datasources/" + unifiedDatasourceId + "/askData" + parameters;
    };
    return UrlUtils;
}());
exports.UrlUtils = UrlUtils;
//# sourceMappingURL=UrlUtils.js.map